export function clipCSS(opts) {
    const { coords } = opts;

    return 'polygon(' + clipPoints(coords).join(', ') + ')';
}

export function clipPoints(coords) {
    return coords.map(i => {
        return i.map(o => {
            return o + '%';
        }).join(' ');
    });
}

export function calcMaxDimensions(x, y, maxWidth, maxHeight) {
    if (y > maxHeight) {
        x = x * (maxHeight / y);
        y = maxHeight;
    }

    if (x > maxWidth) {
        y = y * (maxWidth / x);
        x = maxWidth;
    }

    return { x, y }
}

export function generateRandomID() {
    function chr4(){
        return Math.random().toString(16).slice(-4);
    }

    return [
        chr4() + chr4(),
        chr4(),
        chr4(),
        chr4(),
        chr4() + chr4() + chr4()
    ].join('-');
}


export function removeURIParams(uri) {
    return uri.split('?', 1)[0];
}



// WEBPACK FOOTER //
// ./src/utilities.js